import { Routes, Route, useLocation } from 'react-router-dom';
import useScrollAnimation from './hooks/useScrollAnimation';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ProgrammesPage from './pages/ProgrammesPage';
import ImpactPage from './pages/ImpactPage';
import SDGPage from './pages/SDGPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import DonatePage from './pages/DonatePage';
import ContactPage from './pages/ContactPage';
import AdminLoginPage from './pages/admin/AdminLoginPage';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminPostsPage from './pages/admin/AdminPostsPage';
import AdminPostNewPage from './pages/admin/AdminPostNewPage';
import AdminPostEditPage from './pages/admin/AdminPostEditPage';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import './styles/global.css';

const ROLFWebsite = () => {
  const { pathname } = useLocation();

  useScrollAnimation(pathname);

  return (
    <AuthProvider>
      <div style={{ minHeight: '100vh' }}>
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/programmes" element={<ProgrammesPage />} />
            <Route path="/impact" element={<ImpactPage />} />
            <Route path="/sdg" element={<SDGPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/donate" element={<DonatePage />} />
            <Route path="/contact" element={<ContactPage />} />

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/posts"
              element={
                <ProtectedRoute>
                  <AdminPostsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/posts/new"
              element={
                <ProtectedRoute>
                  <AdminPostNewPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/posts/:postId/edit"
              element={
                <ProtectedRoute>
                  <AdminPostEditPage />
                </ProtectedRoute>
              }
            />

            <Route path="*" element={<HomePage />} />
          </Routes>
        </main>
        <Footer />
        <BackToTop />
      </div>
    </AuthProvider>
  );
};

export default ROLFWebsite;
